function Modal( content ){
  this.content = content;
  this.modalEl = this.setModalEl();
}

Modal.prototype.setModalEl = function ( existingModal ) {
  let modal = existingModal || null;
  //check if existing
  if( document.getElementById('modal') ){
    modal = document.getElementById('modal');
    //delete all children
    while (modal.hasChildNodes()) {
      modal.removeChild(modal.firstChild);
    }
  } else {
    modal = document.createElement('div');
    modal.id = 'modal';
  }
  let modalChild = document.createElement('div');
  //close button
  let closeButton = document.createElement('button');
  closeButton.classList.add('close-modal');
  let closeButtonText = document.createTextNode('Close');
  closeButton.addEventListener( 'click', e => this.removeModal(e) );
  closeButton.appendChild( closeButtonText );
  modalChild.appendChild( closeButton );
  //append new content
  if( this.content ){
    modalChild.appendChild( this.content );
  }
  modal.appendChild( modalChild );
  //set property
  return modal;
};

Modal.prototype.showModal = function () {
  console.log(this.modalEl);
  document.body.appendChild( this.modalEl );

};

Modal.prototype.removeModal = function ( e ) {
  this.modalEl.remove();
}


export default Modal;
